import React from "react";
import { Dictionary } from "lodash";
import { Person } from "@/features/people/graphql/generated";
import { ScorecardRow } from "@/features/scorecards/graphql/generated";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { PdfContainer } from "../../generator";
import { PersonSummary } from "./pages/PersonSummary";
import { HighlightsAndPersonality } from "./pages/Highlights";
import { Values } from "./pages/Values";
import { Competencies } from "./pages/Competencies";

interface CandidateProfilePdfProps {
  profile: Person;
  summary: string;
  dimensions: Dictionary<DimensionWithScores[]>;
  scorecard: any;
  logoUrl?: string;
}

function CandidateProfilePdf(props: CandidateProfilePdfProps) {
  const { dimensions, profile = {} as Person, scorecard, summary } = props;

  if (!profile || !dimensions) return null;

  return (
    <PdfContainer className="relative px-4" key="container">
      {/* Person Summary - Always show if profile exists */}
      <PersonSummary profile={profile} summary={summary} />

      <HighlightsAndPersonality dimensions={dimensions} context="candidate" />

      <Values
        dimensions={dimensions}
        context="candidate"
        defaultPersonId={profile.id!}
        person={profile}
      />

      {/* Competencies - Only show if there are competency dimensions */}
      <Competencies
        dimensions={dimensions}
        context="candidate"
        defaultPersonId={profile.id!}
        person={profile}
        scorecardRows={scorecard.rows as ScorecardRow[]}
      />
    </PdfContainer>
  );
}

export default CandidateProfilePdf;
